__turbopack_context__.v({
  "ant-dropdown-menu": "index-module-scss-module__h4D1wa__ant-dropdown-menu",
  "ant-dropdown-menu-item": "index-module-scss-module__h4D1wa__ant-dropdown-menu-item",
  "ant-dropdown-menu-item-selected": "index-module-scss-module__h4D1wa__ant-dropdown-menu-item-selected",
  "ant-dropdown-menu-title-content": "index-module-scss-module__h4D1wa__ant-dropdown-menu-title-content",
  "back-top-wrap": "index-module-scss-module__h4D1wa__back-top-wrap",
  "container": "index-module-scss-module__h4D1wa__container",
  "filterTableSelect": "index-module-scss-module__h4D1wa__filterTableSelect",
  "spaceContainer": "index-module-scss-module__h4D1wa__spaceContainer",
  "total": "index-module-scss-module__h4D1wa__total",
});
